var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#337FFF",
    d: "m14.808 12.75.342-2.17h-2.107V9.167c0-.593.294-1.173 1.235-1.173h.97V6.146A12 12 0 0 0 13.54 6c-1.734 0-2.865 1.042-2.865 2.924v1.655H8.752v2.17h1.921V18h2.37v-5.25z"
  })));
};
export default SvgFacebook;